import { render, staticRenderFns } from "./CrossSellAccessories.vue?vue&type=template&id=34b80be2&scoped=true"
import script from "./CrossSellAccessories.vue?vue&type=script&lang=js"
export * from "./CrossSellAccessories.vue?vue&type=script&lang=js"
import style0 from "./CrossSellAccessories.vue?vue&type=style&index=0&id=34b80be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b80be2",
  null
  
)

export default component.exports